import { useMemo, useState } from "react";
import { useLocation } from 'react-router-dom';
// Utils
import { isAfter, isEqual, addMinutes } from 'date-fns';
import {timerSession} from '../utils';
import { useLogout, useNotify, useGetIdentity} from 'react-admin';
import { Auth } from "aws-amplify";



export function useSession() {
  const notify = useNotify();
  const logout = useLogout();
  const location = useLocation();
  const { loaded } = useGetIdentity();
  const [modalSession, setModalSession] = useState(false);

  const extendSession = () => {
    window.localStorage.setItem(
      'sessionTime',
      addMinutes(new Date(), 30)
    );
    setModalSession(false);
  }

  const endSession = () => {
    setModalSession(false);
    logout();
    clearInterval(timerSession().timerUpdate)
  }

  useMemo(() => {
    if(loaded) {
      if(
        (isAfter(new Date(), new Date(window.localStorage.getItem('sessionTime'))) ||
        isEqual(new Date(), new Date(window.localStorage.getItem('sessionTime'))))
      ) {
        logout();
        notify('ra.notification.time_session', 'error');
      }else {
        const refreshTokens =async  () => {
          try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            const currentSession = await Auth.currentSession();
            cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
              // console.log('session', err, session);
              // do whatever you want to do now :)
            });
          } catch (e) {
            // console.log('Unable to refresh Token', e);
          }
        }
        refreshTokens();
        window.localStorage.setItem(
          'sessionTime',
          addMinutes(new Date(), 30)
        );
      }
      timerSession(() => setModalSession(true), notify, logout);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, loaded])

  return {
    modalSession,
    setModalSession,
    extendSession,
    endSession
  }
}